var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showMainList,
              expression: "showMainList"
            }
          ],
          staticClass: "main-content",
          attrs: { type: "primary" }
        },
        [
          _c(
            "lcl-search-bar",
            {
              attrs: {
                "is-query-price": true,
                "config-id": "PriceLCL",
                "show-currency": false,
                "is-manage-module": true,
                filter: _vm.filter
              },
              on: {
                onLevelChanged: _vm.onLevelChanged,
                simSearchItemCallBack: _vm.toSimpleQuery,
                advSearchItemResetCallBack: _vm.toAdvancedQuery
              }
            },
            [
              _vm.activeTabName === "cpList"
                ? _c(
                    "template",
                    { slot: "operations" },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.inputAllowed_PP,
                              expression: "inputAllowed_PP"
                            }
                          ],
                          attrs: {
                            no: "onEditCP",
                            type: "primary",
                            disabled: !this.cpSelectRow
                          },
                          on: {
                            click: function($event) {
                              return _vm.onEdit_CP()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.Edit")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.deleteAllowed_CP,
                              expression: "deleteAllowed_CP"
                            }
                          ],
                          attrs: { no: "onDeleteCP", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.onDelete_CP()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.Invalid")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.deleteAllowed_CP,
                              expression: "deleteAllowed_CP"
                            }
                          ],
                          attrs: { no: "onPriceStateCP0", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.onPriceState_CP(0)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.PriceState_Common")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.deleteAllowed_CP,
                              expression: "deleteAllowed_CP"
                            }
                          ],
                          attrs: { no: "onPriceStateCP1", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.onPriceState_CP(1)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.PriceState_Suspend")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.deleteAllowed_CP,
                              expression: "deleteAllowed_CP"
                            }
                          ],
                          attrs: { no: "onPriceStateCP2", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.onPriceState_CP(2)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.PriceState_Reject")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.deleteAllowed_CP,
                              expression: "deleteAllowed_CP"
                            }
                          ],
                          attrs: { no: "onPriceStateCP3", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.onPriceState_CP(3)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.PriceState_Inquiry")))]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.activeTabName !== "cpList"
                ? _c(
                    "template",
                    { slot: "operations" },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.inputAllowed_PP,
                              expression: "inputAllowed_PP"
                            }
                          ],
                          attrs: {
                            no: "onEditPP",
                            type: "primary",
                            disabled: !this.ppSelectRow
                          },
                          on: {
                            click: function($event) {
                              return _vm.onEdit_PP()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.Edit")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            no: "onDeletePP",
                            type: "danger",
                            disabled: !_vm.ppSelectLength
                          },
                          on: {
                            click: function($event) {
                              return _vm.onDelete_PP()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.Delete")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.approveAllowed_PP,
                              expression: "approveAllowed_PP"
                            }
                          ],
                          attrs: {
                            no: "onApprove",
                            disabled: !_vm.ppSelectLength,
                            type: "primary"
                          },
                          on: {
                            click: function($event) {
                              return _vm.onApprove()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.Audit")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.inputAllowed_PP,
                              expression: "inputAllowed_PP"
                            }
                          ],
                          attrs: { no: "onAddPP", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.onAdd_PP()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.Add")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.inputAllowed_PP,
                              expression: "inputAllowed_PP"
                            }
                          ],
                          attrs: { no: "onDownloadTemplate", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.onDownloadTemplate()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.Template")))]
                      ),
                      _c(
                        "el-upload",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.inputAllowed_PP,
                              expression: "inputAllowed_PP"
                            }
                          ],
                          staticStyle: {
                            display: "inline-block",
                            "margin-left": "5px"
                          },
                          attrs: {
                            no: "saveLclExcelFile",
                            action: _vm.URL.price.saveLclExcelFile,
                            headers: { sessionId: _vm.sessionId },
                            "show-file-list": false,
                            accept: ".xls, .xlsx",
                            "on-success": _vm.uploadExcelSuccess,
                            data: {
                              currentOfficeId:
                                _vm.$store.getters.currentOfficeId
                            }
                          }
                        },
                        [
                          _c(
                            "el-button",
                            { attrs: { no: "import", type: "primary" } },
                            [_vm._v(_vm._s(_vm.$t("Pricing.Import")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "tabs-container" },
        [
          _c(
            "el-tabs",
            {
              ref: "tabs",
              staticStyle: { width: "100%" },
              attrs: { type: "card" },
              on: { "tab-click": _vm.handleTabClick },
              model: {
                value: _vm.activeTabName,
                callback: function($$v) {
                  _vm.activeTabName = $$v
                },
                expression: "activeTabName"
              }
            },
            [
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("Pricing.CurrentPrice"),
                    name: "cpList"
                  }
                },
                [
                  _c("lcl-export-remark-data-grid", {
                    ref: "cpList",
                    attrs: {
                      "v-if": _vm.activeTabName === "cpList",
                      "config-module": "224601",
                      "row-data": _vm.rowCpData,
                      "show-create": true,
                      "show-modify": true,
                      "show-approve": true,
                      "show-selection": true,
                      filter: _vm.filter,
                      "grid-options": _vm.cpGridOptions,
                      view: 1
                    },
                    on: { selectRowChange: _vm.selectRowChange }
                  })
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("Pricing.PendingPrice"),
                    name: "ppList"
                  }
                },
                [
                  _c("lcl-export-remark-data-grid", {
                    ref: "ppList",
                    attrs: {
                      "v-if": _vm.activeTabName === "ppList",
                      "config-module": "224602",
                      "row-data": _vm.rowPpData,
                      "show-price-no": false,
                      "show-create": true,
                      "show-modify": true,
                      "show-approve": false,
                      "show-selection": true,
                      filter: _vm.filter,
                      "grid-options": _vm.ppGridOptions,
                      view: 0
                    },
                    on: { selectRowChange: _vm.selectRowChange }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                position: "absolute",
                left: "160px",
                margin: "10px"
              }
            },
            [_c("span", [_vm._v(_vm._s(_vm.globalMsg))])]
          )
        ],
        1
      ),
      _vm.lclFormDialog.visible
        ? _c("lcl-form", {
            attrs: {
              visible: _vm.lclFormDialog.visible,
              price: _vm.lclFormDialog.price,
              "is-new": _vm.lclFormDialog.isNew,
              "is-cp": _vm.activeTabName === "cpList"
            },
            on: {
              close: _vm.onLclFormDialogClose,
              deleteCp: _vm.deleteCp,
              reload: _vm.toQuery,
              supplierChange: function(params) {
                return _vm.supplierChange(params)
              },
              warehouseCallback: function(params) {
                return _vm.warehouseCallback(params)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }